import React from 'react';
import {
    selectedPrescripteursSelector,
    useTiersServiceSelector,
} from '@europrocurement/l2d-domain';
import { GrilleTarifaire } from './GrilleTarifaire';

export const GrilleTarifaireRoute: React.FunctionComponent = function () {
    const prescripteur = useTiersServiceSelector(selectedPrescripteursSelector);

    if (!prescripteur) {
        return null;
    }

    return (
        <GrilleTarifaire
            selectedPrescriberId={prescripteur?.id}
            showAction={false}
            surchargeAL={false}
            surchargeFD={false}
            surchargeHonoraire={false}
            showTTC
            showOffer={false}
            showNumberCatalogue={false}
            showElement={false}
            showChips={false}
            waitPrescripteur
        />
    );
};

export default GrilleTarifaireRoute;
